<template>
 <!-- 凭证 -->
  <el-dialog  title="提现详情"  :visible.sync="dialog" width="900px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="提现中" name="1"></el-tab-pane>
        <el-tab-pane label="提现成功" name="0"></el-tab-pane>
        <el-tab-pane label="提现失败" name="2"></el-tab-pane>
      </el-tabs>
       <el-table :data="tableList"  border bordersize="mini" height="400" center highlight-current-row style="width: 100%;margin-top:10px;"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        v-loading="loading"
       >
        <el-table-column property="zxTansferNo" label="银行流水号" v-if="activeName==='0'"  align="center"  show-overflow-tooltip></el-table-column>
         <el-table-column label="操作" width="170"  v-if="activeName==='0'">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" btnCode="00JP007B004"  @click="huidanFn(scope.row)">银行回单</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="drawalMoney"   label="金额" align="center"  ></el-table-column>
        <el-table-column prop="extertransType"  label="状态"  align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
            <span v-if="scope.row.drawalStatus == '0'">提现成功</span>
            <span v-if="scope.row.drawalStatus == '1'">提现中</span>
            <span v-if="scope.row.drawalStatus == '2'">提现失败</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="applyTime" label="申请时间"  align="center" :formatter="dateTimeFormat" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
     <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
      </span>
   </el-dialog>

</template>

<script>
import { tWithdrawalInfoList } from '@/api/consignment'
import { dateTimeFormat } from '@/utils/util'
import { chaKanHuiDan } from '@/utils/chaKanHuiDan'
export default {
  name: 'lookVoucher',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dialog: false,
      tableList: [],
      activeName: '1',
      loading: true

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
    this.loading = true
    tWithdrawalInfoList({ costId: this.rowData.id, drawalStatus: 1 }).then(res => {
      this.loading = false
      this.tableList = res
    })
  },
  methods: {
    huidanFn (row) {
      chaKanHuiDan(row.zxTansferNo, row.createTime)
    },
    handleClick () {
      this.loading = true
      tWithdrawalInfoList({ costId: this.rowData.id, drawalStatus: this.activeName }).then(res => {
        this.loading = false
        this.tableList = res
      })
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
</style>
